import React, { useState, useEffect } from 'react';

const ecomTestimonialsData = [
  {
    id: 1,
    quote:
      'Experts Communication rebuilt our Shopify Plus store with a headless architecture. Our mobile page load times dropped under 1.2s and our checkout conversion rate surged by +48% in the first quarter alone. Phenomenal team!',
    author: 'Liam Thorne',
    designation: 'Founder & CEO, Thorne Decor',
    avatar: '/assets/images/team_member_1.png'
  },
  {
    id: 2,
    quote:
      'Transitioning our high-volume multi-warehouse catalog to a custom Magento platform was executed without a single minute of downtime. Their ERP integration and automated inventory sync saved us hundreds of operational hours.',
    author: 'Amina Al-Sayed',
    designation: 'E-Commerce Director, Radion Electronics',
    avatar: '/assets/images/team_member_2.png'
  },
  {
    id: 3,
    quote:
      'The conversion optimization and UX audit they performed on our digital storefront transformed our brand. Average Order Value (AOV) grew by 35% and customer checkout abandonment reached an all-time low.',
    author: 'Marcus Vance',
    designation: 'VP of Digital Growth, Luxrio Watches',
    avatar: '/assets/images/team_member_3.png'
  },
  {
    id: 4,
    quote:
      'From custom Liquid theme coding to automated CRM flows, Experts Communication delivered beyond our highest expectations. They are our trusted long-term tech partners for all digital commerce.',
    author: 'Jessica Reynolds',
    designation: 'Co-Founder, Sweet Pink Apparel',
    avatar: '/assets/images/hr-manager.jpg'
  }
];

function EcommerceTestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto slide smoothly every 4.5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % ecomTestimonialsData.length);
    }, 4500);

    return () => clearInterval(timer);
  }, []);

  const handleAuditClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('ecommerce-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  const currentTestimonial = ecomTestimonialsData[currentIndex];

  return (
    <section className="ecom-testimonial-section">
      <div className="container bpo-testimonial-container">
        {/* Left Column: Headings, Sliding Card, and Button */}
        <div className="bpo-testimonial-left">
          <span className="bpo-testimonial-tag">
            What store owners say about us!
          </span>

          <h2 className="bpo-testimonial-title">
            Building Online Stores That <span className="text-red">Scale Millions in Revenue</span>
          </h2>

          <p className="bpo-testimonial-desc">
            Explore verified reviews and conversion milestones from founders, enterprise retailers, and global brand managers who scaled their e-commerce business with Experts Communication.
          </p>

          {/* Testimonial Card (Solid Black with White Text) */}
          <div className="bpo-testimonial-card-wrapper">
            <div className="bpo-testimonial-card" key={currentTestimonial.id}>
              {/* Star Rating */}
              <div className="bpo-stars-row">
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
                <span className="bpo-star">★</span>
              </div>

              {/* Review Quote Text */}
              <p className="bpo-quote-text">
                "{currentTestimonial.quote}"
              </p>

              {/* Client Info & Quotation Icon */}
              <div className="bpo-client-row">
                <div className="bpo-client-info">
                  <img 
                    src={currentTestimonial.avatar} 
                    alt={currentTestimonial.author} 
                    className="bpo-client-avatar"
                  />
                  <div className="bpo-client-details">
                    <h4 className="bpo-client-name">{currentTestimonial.author}</h4>
                    <span className="bpo-client-role">{currentTestimonial.designation}</span>
                  </div>
                </div>

                {/* Quotation Symbol */}
                <div className="bpo-quote-icon">
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="rgba(255, 255, 255, 0.4)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2H4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.75-2-2-2h-4c-1.25 0-2 .75-2 2v6c0 1.25.75 2 2 2h4c0 4-2 6-5 8z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <button className="btn-bpo-explore" onClick={handleAuditClick}>
            Get Free Store Audit
          </button>
        </div>

        {/* Right Column: 5-Star Reviews Showcase Graphic */}
        <div className="bpo-testimonial-right">
          <div className="bpo-reviews-img-wrapper">
            <img 
              src="/assets/images/bpo_reviews_neon.jpg" 
              alt="5-Star E-commerce Reviews Customer Showcase" 
              className="bpo-reviews-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default EcommerceTestimonialsSlider;
